import { LifeBuoy, ScanLine } from 'lucide-react';
import { QCM_GREEN } from '../../utils/qcmTheme';

/**
 * Le pied de l'écran de scan : la saisie de secours, et LE bouton (chantier
 * jeton, 2026-09-04). Un seul geste par question, toujours au même endroit :
 * « Suivant » révèle ou avance selon le réglage de la séance, « Terminer » sur
 * la dernière carte. C'est `ScanMobile` qui décide ce que le geste fait ; ici
 * on ne porte que le libellé et le clic.
 *
 * « Scan ! » (2026-09-19) : tant que le prof n'a pas appuyé, la caméra tourne
 * mais n'analyse rien. Il lit la question, laisse réfléchir, fait lever, puis
 * appuie. Le bouton disparaît une fois pressé et revient à la question
 * suivante. « Suivant » reste accessible en dessous : sauter une question
 * sans la scanner reste possible.
 */
const ScanFooter = ({ libelle, disabled, onSuivant, onOuvrirSecours, scanPossible = false, onScan }) => (
  <div className="px-4 pb-5">
    {scanPossible ? (
      <button
        type="button"
        onClick={onScan}
        className="w-full mb-2.5 py-[15px] rounded-2xl text-base font-black text-white flex items-center justify-center gap-2 transition"
        style={{ background: '#2563eb', boxShadow: '0 6px 20px rgba(37,99,235,.35)' }}
      >
        <ScanLine size={18} />
        Scan !
      </button>
    ) : null}
    <div className="flex gap-2.5">
      <button
        type="button"
        onClick={onOuvrirSecours}
        aria-label="Saisie de secours"
        className="flex items-center gap-1.5 px-4 rounded-2xl text-white text-[13px] font-semibold"
        style={{ background: 'transparent', border: '1.5px solid rgba(255,255,255,.27)' }}
      >
        <LifeBuoy size={15} />
        Secours
      </button>
      <button
        type="button"
        onClick={onSuivant}
        disabled={disabled}
        className="flex-1 py-[15px] rounded-2xl text-base font-bold text-white transition disabled:opacity-60"
        style={{ background: QCM_GREEN }}
      >
        {libelle}
      </button>
    </div>
  </div>
);

export default ScanFooter;
